import { getConstant } from '../utils';

export const getCalculatorsAcidity = getConstant('GET_CALCULATORS_ACIDITY');
export const getCalculatorsAcidityItem = getConstant('GET_CALCULATORS_ACIDITY_ITEM');